import { CoachingFormData } from './types';

interface Props {
  data: CoachingFormData;
  onChange: (updates: Partial<CoachingFormData>) => void;
  errors: Record<string, string>;
}

export default function IntakeStep1BasicInfo({ data, onChange, errors }: Props) {
  return (
    <div>
      <h3
        className="text-xl md:text-2xl font-light text-[#1E2D5E] mb-1"
        style={{ fontFamily: "'Cormorant Garamond', serif" }}
      >
        Let&apos;s Start with the Basics
      </h3>
      <p className="text-sm text-[#1E2D5E]/60 mb-7 leading-relaxed">
        Just a few quick details so we know how to reach you.
      </p>

      <div className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-[#1E2D5E] mb-1.5">
            Full Name <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            name="full_name"
            value={data.full_name}
            onChange={(e) => onChange({ full_name: e.target.value })}
            placeholder="Jane Smith"
            className={`w-full px-4 py-3 rounded-lg border text-[#1E2D5E] text-sm bg-white focus:outline-none transition-colors ${
              errors.full_name ? 'border-red-400' : 'border-[#C9A96E]/30 focus:border-[#C9A96E]'
            }`}
          />
          {errors.full_name && <p className="text-xs text-red-400 mt-1">{errors.full_name}</p>}
        </div>

        <div>
          <label className="block text-sm font-medium text-[#1E2D5E] mb-1.5">
            Email Address <span className="text-red-400">*</span>
          </label>
          <input
            type="email"
            name="email"
            value={data.email}
            onChange={(e) => onChange({ email: e.target.value })}
            placeholder="jane@example.com"
            className={`w-full px-4 py-3 rounded-lg border text-[#1E2D5E] text-sm bg-white focus:outline-none transition-colors ${
              errors.email ? 'border-red-400' : 'border-[#C9A96E]/30 focus:border-[#C9A96E]'
            }`}
          />
          {errors.email && <p className="text-xs text-red-400 mt-1">{errors.email}</p>}
        </div>

        <div>
          <label className="block text-sm font-medium text-[#1E2D5E] mb-1.5">
            City &amp; State <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            name="location"
            value={data.location}
            onChange={(e) => onChange({ location: e.target.value })}
            placeholder="Portland, OR"
            className={`w-full px-4 py-3 rounded-lg border text-[#1E2D5E] text-sm bg-white focus:outline-none transition-colors ${
              errors.location ? 'border-red-400' : 'border-[#C9A96E]/30 focus:border-[#C9A96E]'
            }`}
          />
          <p className="text-xs text-[#1E2D5E]/45 mt-1.5">
            Note: Psychiatric services (evaluation &amp; medication) are available to Oregon residents only. Coaching may be available outside Oregon.
          </p>
          {errors.location && <p className="text-xs text-red-400 mt-1">{errors.location}</p>}
        </div>

        <div>
          <label className="block text-sm font-medium text-[#1E2D5E] mb-1.5">
            Phone Number <span className="text-[#1E2D5E]/40 text-xs font-normal">(optional)</span>
          </label>
          <input
            type="tel"
            name="phone"
            value={data.phone}
            onChange={(e) => onChange({ phone: e.target.value })}
            placeholder="(503) 555-0100"
            className="w-full px-4 py-3 rounded-lg border border-[#C9A96E]/30 text-[#1E2D5E] text-sm bg-white focus:outline-none focus:border-[#C9A96E] transition-colors"
          />
        </div>
      </div>
    </div>
  );
}
